import { parsePhoneNumberFromString, getCountries, getCountryCallingCode } from 'libphonenumber-js';

const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const sanitizedNumber = phoneNumber.toString().trim();
    let parsedNumber;
    parsedNumber = parsePhoneNumberFromString(sanitizedNumber);
    if (!parsedNumber || !parsedNumber.country) {
      const countries = getCountries();   // list of countries
      for (let country of countries) {
        const countryCode = getCountryCallingCode(country);
        if (sanitizedNumber.startsWith(countryCode)) {    // country code matcher
          parsedNumber = parsePhoneNumberFromString(`+${sanitizedNumber}`);
          break;
        }
      }
    }
    return parsedNumber ? parsedNumber.formatInternational() : sanitizedNumber;
  };


  export default {
    formatPhoneNumber
  };